import React, {Component} from 'react';
import {HashRouter as Router, Route, Switch} from 'react-router-dom';

// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import 'Style/style.scss'
// Temp fix for reactstrap
import 'Style/core/_dropdown-menu-right.scss';

import settings from 'Root/settings.json';

// Containers
import {Full} from 'App/containers/index';

// Views
import {
  Login,
  Register,
  Homepage
} from 'App/views/index';

// redux
import {connect} from 'react-redux';



// Last Location
import { LastLocationProvider } from 'react-router-last-location';

// graphql
import {selectors as authSel} from 'App/util/redux/auth/reducer';

import * as helper from 'App/util/common/helper';

// auto refresh session
import Verify from 'App/views/Pages/Verify';
import {
  actions as socketActions
} from 'App/util/redux/socket/index';

import {
  actions as authActions
} from 'App/util/redux/auth/index';

import {
  actions as autoLogoutActions
} from 'App/util/redux/autoLogout/index';
import {applicationStore} from 'App/index';
import axios from 'axios';

const {
  timerRefreshRequest
} = autoLogoutActions;

const {
  authRefreshSession
} = authActions;

const {
  wsConnect,
  wsListen,
} = socketActions;

const mapStateToProps = (state) => ({
  user: authSel.user(state)
});
const mapDispatchToProps = (dispatch) => ({
  wsConnect: (user) => dispatch(wsConnect(user)),
  authRefreshSession: () => dispatch(authRefreshSession()),
  timerRefreshRequest: () => dispatch(timerRefreshRequest()),
  wsListen: (key, subject, cb) => dispatch(wsListen(key, subject, cb))
});

@connect(
  mapStateToProps,
  mapDispatchToProps
)
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastUpdated: null
    };
  }

  componentDidMount() {
    if (this.activeSession()) {
      this.props.wsListen('refresh_token',
        'app',
        (payload) => {
          applicationStore.dispatch(timerRefreshRequest());
        }
      );
    }

    axios.get(`//${settings.url}/last_db_refresh.json`, {
      headers: {'crossDomain': true},
    })
      .then(res => {
        this.setState({lastUpdated: res.data.date});
      }).catch(function (error) {
      // handle error
      console.log(error);
    });

    // this.setState({lastUpdated: '30 July 2018 16:48 CEST'});
  }

  componentWillUnmount() {
    helper.cb_autoLogout(applicationStore.dispatch);
  }

  activeSession() {
    return this.props.user !== null;
  }

  render() {
    // if new tab/window gets opened
    if (this.activeSession()) {
      // establish ws connection
      this.props.wsConnect(this.props.user);
      // refresh session
      this.props.authRefreshSession();
    }

    return (
      <div>
        <Router>
          <LastLocationProvider>
            <Switch>
              <Route exact path="/" name="Homepage" render={() =>
                <Homepage lastUpdated={this.state.lastUpdated}/>
              }/>
              {/*<Redirect exact from='/' to={helper.getPath()}/>*/}
              <Route path="/register" name="Register" component={Register}/>
              <Route path="/login" name="Login" component={Login}/>
              <Route path="/verify" name="Verify" component={Verify}/>

              <Route path={helper.getPath()} name="Home" render={() => (
                this.activeSession() ? (
                  <Full lastUpdated={this.state.lastUpdated} user={this.props.user}/>
                ) : (
                  <Login/>
                )
              )}/>
            </Switch>
          </LastLocationProvider>
        </Router>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js